import {InputNumber} from "antd";
import React from "react";

const InputDollar = React.forwardRef((props: InputNumber, ref: any) => {
    return (
        <InputNumber
            ref={ref}
            step={0.01}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            {...props}
        />
    )
});

InputDollar.displayName = "InputDollar";

export default InputDollar;
